<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.0001 4V20.0001H2V4H22.0001ZM20 7.22752L12.0208 14.3343L4.00012 7.21959V18H20V7.22752ZM12.0142 11.6654L5.62778 6.00012H18.3752L12.0142 11.6654Z"
    />
  </svg>
</template>
